module.exports = __webpack_public_path__ + "static/media/kocka1DRV.98ca5df3.png";